import { Button, Empty, Radio, Tag, useUpdate } from '@maxtropy/components';
import { RadioChangeEvent, Space, Spin } from 'antd';
import { FC, Key, useEffect, useRef, useState } from 'react';
import CircuitTabContent from '../CircuitTabContent';
import AddCircuitModal, { AddCircuitModalRef } from '../AddCircuitModal';
import styles from './index.module.scss';
import { distributionCabinetBandCircuits } from '@/api/distributionCabinetManage';
import { PlusOutlined } from '@ant-design/icons';
import { CabinetListCircuitWithDataItem, NodeType, RoomListCircuitWithDataItem } from '../../utils';
import {
  apiV2DistributionCabinetListCircuitWithDataPost,
  apiV2DistributionCabinetListWithCircuitByRoomIdPost,
} from '@maxtropy/device-customer-apis-v2';
import cabinetIcon from '../../imgs/cabinet.svg';
import { useNavigate } from 'react-router-dom';

export interface ICircuitListProps {
  selectedId?: Key;
  selectedType?: NodeType;
  editVideo: (node: any) => void;
}

const CircuitList: FC<ICircuitListProps> = props => {
  const { selectedId, selectedType, editVideo } = props;
  const addCircuitRef = useRef<AddCircuitModalRef>(null);
  const [visible, setVisible] = useState<boolean>(false);
  const [currentKey, setCurrentKey] = useState<string>('1');
  const [circuitList, setCircuitList] = useState<CabinetListCircuitWithDataItem[]>([]);
  const [roomList, setRoomList] = useState<RoomListCircuitWithDataItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [refreshState, refresh] = useUpdate();
  const timer = useRef<number>();

  const navigate = useNavigate();

  // 每隔1min执行一次请求
  useEffect(() => {
    if (selectedId && currentKey) {
      clearTimeout(timer.current);
      timer.current = window.setTimeout(() => {
        refresh();
      }, 60000);
    }
    return () => clearTimeout(timer.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId, currentKey, refreshState]);

  useEffect(() => {
    if (selectedId && currentKey) {
      setLoading(true);
      if (selectedType === NodeType.CABINET) {
        apiV2DistributionCabinetListCircuitWithDataPost({ id: selectedId, orderBy: Number(currentKey) })
          .then(res => {
            setCircuitList(res?.list ?? []);
          })
          .finally(() => setLoading(false));
      } else {
        apiV2DistributionCabinetListWithCircuitByRoomIdPost({ id: selectedId, orderBy: Number(currentKey) })
          .then(res => {
            setRoomList(res.list ?? []);
          })
          .finally(() => setLoading(false));
      }
    }
  }, [selectedId, currentKey, selectedType, refreshState]);

  const btnGroup = [
    {
      key: '1',
      label: '按电量',
    },
    {
      key: '2',
      label: '按功率',
    },
  ];

  const onOk = () => {
    if (addCircuitRef.current?.selectedRowKeys.length) {
      // 回路绑定配电柜
      distributionCabinetBandCircuits(
        selectedId!,
        addCircuitRef.current?.selectedRowKeys.map(i => i as number)
      ).then(_ => {
        setVisible(false);
        refresh();
      });
    }
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Radio.Group
          onChange={(e: RadioChangeEvent) => {
            setCurrentKey(e.target.value);
          }}
          value={currentKey}
          buttonStyle="solid"
        >
          {btnGroup?.map(btn => (
            <Radio.Button key={btn.key} value={btn.key}>
              {btn.label}
            </Radio.Button>
          ))}
        </Radio.Group>
        {selectedType === NodeType.CABINET && (
          <Button type="primary" onClick={() => setVisible(true)} icon={<PlusOutlined />}>
            添加回路
          </Button>
        )}
        {selectedType === NodeType.ROOM && (
          <Space size={8}>
            <Button type="primary" onClick={() => editVideo({ id: selectedId })}>
              编辑视频监控
            </Button>
            <Button
              type="primary"
              onClick={() => navigate(`/dc/circuit/distributionCabinetManage/videoList/${selectedId}`)}
            >
              查看视频监控
            </Button>
          </Space>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ display: 'flex', paddingTop: 10 }}>
          <div className={styles.legend} style={{ marginRight: 24 }}>
            <div className={styles.Eleclegend}></div>
            <span>本日电量</span>
          </div>
          <div className={styles.legend}>
            <div className={styles.Powerlegend}></div>
            <span>实时功率</span>
          </div>
        </div>
      </div>

      <Spin spinning={loading}>
        <div style={{ height: 'calc(100vh - 260px)', overflowY: 'auto', padding: '0 16px', overflowX: 'hidden' }}>
          {NodeType.CABINET === selectedType ? (
            <CircuitTabContent circuitList={circuitList} />
          ) : (
            <>
              {roomList.length ? (
                <>
                  {roomList.map(k => (
                    <div key={k.cabinetId}>
                      <div className={styles.cabinetTitle}>
                        <img src={cabinetIcon} alt="" />
                        <div className={styles.cabinetName}>{k.cabinetName}</div>
                        <Tag border="solid" color="default">
                          配电柜
                        </Tag>
                      </div>
                      <div className={styles.cabinetBox}>
                        <CircuitTabContent circuitList={k.circuitList}></CircuitTabContent>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <Empty description="该站房下暂无回路" style={{ marginTop: 200 }} />
              )}
            </>
          )}
        </div>
      </Spin>
      <AddCircuitModal
        ref={addCircuitRef}
        visible={visible}
        onOk={onOk}
        onCancel={() => setVisible(false)}
        selectedDistributionId={selectedId}
        circuitList={circuitList}
      />
    </>
  );
};

export default CircuitList;
